import * as React from 'react';
import { BaseComponent } from '../../BaseComponent';
import { OAPStoreState, OAPStore } from '../../../stores/OAPStore';
import { LayoutType } from '../../../constants/LayoutConstants';
import { ViewSettingsStore } from '../../../stores/ViewSettingsStore';
import { OAPActions } from '../../../actions/OAPActions';
import { OAPValues } from './OAPValues';
import { OAPProperties } from './OAPProperties';
import { OAPClasses } from './OAPClasses';

interface OAPPopupState extends OAPStoreState {
    layoutType: LayoutType;
}

export class OAPPopup extends BaseComponent<{}, OAPPopupState> {
    public componentWillMount(): void {
        this.addStoreListener(OAPStore, this.onChange);
        this.addStoreListener(ViewSettingsStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        if (!this.state.showEditor) {
            return null;
        }
        const wrapperProps: React.HTMLProps<HTMLDivElement> = {};
        wrapperProps.style = {
            height: 10,
            left: this.state.position && this.state.position.left ? this.state.position.left : '50%',
            position: 'absolute',
            top: this.state.position && this.state.position.top ? this.state.position.top : '50%',
            transform: 'translate(-50%, -50%)',
            width: 10,
            zIndex: 2
        };
        return (
            <div className="overlay-frame overlay-full" style={{background: 'transparent'}}>
                <div
                    style={{
                        width: '100%', height: '100%', display: 'block', zIndex: 1
                    }}
                    onClick={OAPActions.hideDialog}
                />
                <div {...wrapperProps}>
                    {this.popup()}
                </div>
            </div>
        );
    }

    protected onChange = (): void => {
        this.setState(jQuery.extend(
            {},
            OAPStore.getState(),
            {layoutType: ViewSettingsStore.getState().layoutType}
        ));
    };

    protected popup = (): JSX.Element => {
        if (this.state.selectedProperty != null) {
            return (
                <OAPValues {...this.state}/>
            );
        }

        if (this.state.selectedClass != null) {
            return (
                <OAPProperties {...this.state}/>
            );
        }

        return <OAPClasses {...this.state}/>;
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/popupmenu/OAP/OAPPopup.tsx